import axios from 'axios'
import appConfig from "@/config";
console.log(appConfig.apiBaseUrl);
// 创建一个 Axios 实例
const apiClient = axios.create({
    // baseURL: 'https://lsgsk.cxcwwlkj.com:6699', // 替换为你的 API 基础 URL
    baseURL: appConfig.apiBaseUrl,
    timeout: 10000, // 请求超时时间
});

// 请求拦截器
apiClient.interceptors.request.use(
    (config) => {
        // 从某个地方获取 token，这里假设从 localStorage 中获取
        // if (token) {
        config.headers['customerId'] = localStorage.getItem('token');
        config.headers['UserId'] = localStorage.getItem('token');
        // }
        // 在发送请求之前做些什么，比如添加其他头信息
        return config;
    },
    (error) => {
        // 对请求错误做些什么
        return Promise.reject(error);
    }
);

// 响应拦截器
apiClient.interceptors.response.use(
    (response) => {
        // 对响应数据做点什么，比如统一处理错误码
        return response;
    },
    (error) => {
        // 对响应错误做点什么，比如显示错误消息
        // 你可以根据错误状态码来判断是哪种错误，并作出相应处理
        if (error.response && error.response.status === 401) {
            // 未授权，重定向到登录页面或者执行其他操作
        }
        return Promise.reject(error);
    }
);

// 定义接口函数
// eslint-disable-next-line no-async-promise-executor
export const generalGET = (parms) => new Promise(async resolve => {
    const response = await apiClient.get(parms);
    return resolve(await response.data);
})

// 其他接口函数...
export const generalPOST = async (parms, object) => {
    // eslint-disable-next-line no-useless-catch
    try {
        const response = await apiClient.post(parms, object);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// 图片路径
export const imageurl = appConfig.bannerBaseUrl
export const newImageUrl =  appConfig.newImageUrl

// ... 其他 API 函数
